import { AuthContext } from './context'
import PropTypes from 'prop-types'
import React from 'react'

class AuthPanel extends React.Component {

  static contextType = AuthContext

  static propTypes = {
    children: PropTypes.node.isRequired,
    direction: PropTypes.string
  }

  render() {
    const { shaking } = this.context
    const { direction } = this.props
    const classes = ['maha-auth-panel']
    if(shaking) classes.push('animating transition shake')

    return (
      <div className={classes.join(' ')}>
        <div className="maha-auth-panel-header">
          <img src="/images/signin/truevail-logotype-white.png" alt="TrueVail" />
        </div>
        <div className={`maha-auth-panel-content ${direction || 'forward'}`}>
          {this.props.children}
        </div>
      </div>
    )
  }

}

export default AuthPanel
